module.exports = __webpack_public_path__ + "img/色相饱和度1拷贝2@2x.f2c3ffb0.png";